import DeptPage from "@/pages/zones/DeptPage";
import { departmentsData } from "@/mocks/departments";

export default function HautsDeSeine92Page() {
  return <DeptPage dept={departmentsData["hauts-de-seine-92"]} />;
}
